const encodeSpl = (str) => {
    const encodedStr = str.replaceAll('&','@').replaceAll('=','*')
    return encodedStr;
  };
  
  export default encodeSpl;
  